/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ProfiloEsercenteDTO } from '../model/models';
import { ProfiloEsercenteUpdateForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface UpdateProfiloEsercenteRequestParams {
    profiloEsercenteUpdateForm: ProfiloEsercenteUpdateForm;
}


export interface EsercenteProfiloServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Legge il profilo dell\&#39;esercente autenticato.
     * Ritorna il ProfiloEsercente del caller (ragione sociale, P.IVA, PEC, sede, indirizzo, IBAN, CCIAA) + email di login (read-only) e version per l\&#39;optimistic lock. 404 se il caller non ha un profilo.
     * @endpoint get /api/v1/esercente/profilo
*/
    getProfiloEsercente(extraHttpRequestParams?: any): Observable<ProfiloEsercenteDTO>;

    /**
     * Corregge il profilo dell\&#39;esercente autenticato.
     * PUT-replace dei dati impresa con optimistic lock (rispedire la version letta via GET; 409 su mismatch). NON modifica l\&#39;email di login. 400 se la P.IVA collide con un altro esercente.
     * @endpoint put /api/v1/esercente/profilo
* @param requestParameters
     */
    updateProfiloEsercente(requestParameters: UpdateProfiloEsercenteRequestParams, extraHttpRequestParams?: any): Observable<ProfiloEsercenteDTO>;

}
